import { LoaddingService } from './../../providers/loadding.service';
import { GameOrderDetailPage } from './gameorderdetail';
import { GameSearchPage } from './search';
import { PageDefault } from './../PageDefault';
import { AppConfig } from './../../app/app.config';
import { VrService } from './../../services/vr.service';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

/**
 * Generated class for the VrgamereportPage page.
 * VR游戏记录列表
 * TQQ 2018-01-26
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
// @IonicPage({ name: 'vrgamereport' })
@Component({
  selector: 'page-vrgamereport',
  templateUrl: 'vrgamereport.html',
})
export class VrgamereportPage {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private vrService: VrService,
    private config: AppConfig,
    private modalCtrl: ModalController,
    private loading: LoaddingService
  ) { }

  states = [
    { code: 0, name: '未颁奖' },
    { code: 1, name: '撤单' },
    { code: 2, name: '未中奖' },
    { code: 3, name: '已中奖' },
    { code: 4, name: '未投注' },
    { code: 5, name: '取消投注' },
    { code: 6, name: '中后取消投注' }
  ];
  paras = {
    userName: this.config.getCurrentUser().UserName,
    issueNumber: '',
    state: '',
    startDate: PageDefault.endNowDate(),
    endDate: PageDefault.endDate(),
    pageIndex: 1,
    pageSize: PageDefault.PageSize()
  };
  modelList = [];
  hasmore = false;
  isHave = true;

  ionViewDidLoad() {
    this.getBetReport();
  }

  //下拉重新加载
  //TQQ 2018-01-25
  doRefresh(refresher) {
    this.paras.pageIndex = 1;
    this.getBetReport().then(() => {
      refresher.complete();
    });
  }

  //上拉获取下一页信息
  //TQQ 2018-01-25
  doInfinite(infiniteScroll) {
    this.paras.pageIndex++;
    this.getBetReport().then(() => {
      infiniteScroll.complete();
    });
  }

  //查询条件
  //TQQ 2018-01-25
  presentFilter() {
    let modal = this.modalCtrl.create(GameSearchPage, { paras: this.paras, states: this.states });
    modal.present();
    modal.onWillDismiss(data => {
      if (data) {
        this.paras = data;
        this.getBetReport();
      }
    });
  }

  //获取vr游戏信息
  //TQQ 2018-01-25
  getBetReport() {
    let load = this.loading.showLoding();
    return this.vrService.getBetReport(this.paras).then(s => {
      if (s.List != null) {
        if (this.paras.pageIndex == 1) {
          this.modelList = [];
          this.modelList = s.List;
          if (s.List.length < s.PageCount) {
            this.hasmore = true;
          } else {
            this.hasmore = false;
          }
        } else {
          this.modelList = this.modelList.concat(s.List);
          if (this.modelList.length < s.PageCount) {
            this.hasmore = true;
          }
          else {
            this.paras.pageIndex = 1;
            this.hasmore = false;
          }
        }
      } else {
        this.modelList = [];
      }
      if (this.modelList.length < 1) {
        this.isHave = false;
      } else {
        this.isHave = true;
      }
      this.loading.closeLoading(load);
    }).catch(() => {
      this.loading.closeLoading(load);
    });
  }

  //vr订单详情
  //TQQ 2018-01-26
  getOrderDetail(item) {
    let modal = this.modalCtrl.create(GameOrderDetailPage, { order: item, states: this.states });
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/vrgamereport/vrgamereport.ts